/* eslint-disable react/prop-types */
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { FormikMultiSelect, FormikToggleCheckbox } from '../../../../../components/FormikFields'
import SectionContentContainer from '../../../engage/modals/OnboardUserModal/common/SectionContentContainer'
import { FormOptionsContext, useFormOptions } from '../../../engage/modals/OnboardUserModal/FormOptionsProvider'
import { FORM_FIELDS } from '../constants'

function Groups(props) {
  const { allEmployeesGroups } = props

  // Get group options from FormOptionsProvider pattern
  const formOptions = useFormOptions({
    allEmployeesGroups: allEmployeesGroups || [],
  })

  return (
    <FormOptionsContext.Provider value={formOptions}>
      <div className="section px-4 py-4">
        <Row className="mb-3">
          <Col sm="12">
            <h6 className="fw-bold mb-2" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              <FormattedMessage id="ENGAGE.ONBOARD.ADD_TO_GROUPS" />
            </h6>

            <SectionContentContainer>
              <Row className="mb-1">
                <Col md={6}>
                  <FormikMultiSelect
                    id={FORM_FIELDS.M365_GROUPS}
                    title="ENGAGE.M365_GROUPS"
                    options={formOptions.m365GroupOptions}
                  />
                </Col>
              </Row>
            </SectionContentContainer>

            <hr className="mb-3" />

            <h6 className="fw-bold mb-2" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              <FormattedMessage id="ENGAGE.ONBOARD.ADD_TO_SECURITY_GROUPS" />
            </h6>

            <SectionContentContainer>
              <Row className="mb-1">
                <Col md={6}>
                  <FormikMultiSelect
                    id={FORM_FIELDS.SECURITY_GROUPS}
                    title="ENGAGE.SECURITY_GROUPS"
                    options={formOptions.securityGroupOptions}
                  />
                </Col>
              </Row>
            </SectionContentContainer>

            <hr className="mb-3" />

            <h6 className="fw-bold mb-2" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              <FormattedMessage id="ENGAGE.ONBOARD.POWERSHELL_ACCESS_SETTINGS" />
            </h6>

            <SectionContentContainer>
              <Row>
                <Col md={12}>
                  <FormikToggleCheckbox
                    id={FORM_FIELDS.ENABLE_POWERSHELL_ACCESS}
                    label={<FormattedMessage id="ENGAGE.ENABLE_POWERSHELL_ACCESS" />}
                    className="checkbox-left-aligned auto-z-index"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="mt-2 text-muted">
                    <FormattedMessage id="ENGAGE.ENABLE_POWERSHELL_ACCESS_DESCRIPTION" />
                  </div>
                </Col>
              </Row>
            </SectionContentContainer>
          </Col>
        </Row>
      </div>
    </FormOptionsContext.Provider>
  )
}

export default Groups
